import React, { useState, useEffect, useCallback, useRef } from 'react';
import api from '../services/api';
import { useSocket } from '../hooks/useSocket';

const C = {
  bg:'#0f172a', bg2:'#1e293b', bg3:'#0d1525',
  border:'#334155', text:'#f1f5f9', sub:'#94a3b8', muted:'#475569',
  blue:'#0ea5e9', green:'#22c55e', yellow:'#f59e0b',
  red:'#ef4444', purple:'#8b5cf6', teal:'#14b8a6', pink:'#ec4899'
};

const TIPO_NO = {
  inicio:    { cor:C.teal,   icone:'▶', label:'Início' },
  mensagem:  { cor:C.blue,   icone:'💬', label:'Mensagem' },
  pergunta:  { cor:C.purple, icone:'❓', label:'Pergunta' },
  condicao:  { cor:C.yellow, icone:'⚡', label:'Condição' },
  aguardar:  { cor:C.muted,  icone:'⏳', label:'Aguardar' },
  acao:      { cor:C.pink,   icone:'⚙️', label:'Ação' },
  ia:        { cor:'#f97316',icone:'🤖', label:'IA (Gemini)' },
  fim:       { cor:C.green,  icone:'⏹', label:'Fim' },
};

const CONDICOES = [
  { val:'opcao_1', label:'Opção 1 (SIM)' },
  { val:'opcao_2', label:'Opção 2 (NÃO)' },
  { val:'opcao_3', label:'Opção 3' },
  { val:'opcao_4', label:'Opção 4' },
  { val:'outro',   label:'Qualquer outra resposta' },
  { val:'timeout', label:'Sem resposta (timeout)' },
  { val:'sempre',  label:'Sempre (incondicional)' },
];

const s = {
  page:   { display:'flex', flexDirection:'column', height:'calc(100vh - 80px)' },
  tbar:   { display:'flex', alignItems:'center', gap:12, marginBottom:16 },
  title:  { fontSize:20, fontWeight:700, color:C.text },
  btn:    { background:C.blue, color:'#fff', border:'none', borderRadius:8, padding:'8px 18px', cursor:'pointer', fontSize:13, fontWeight:600 },
  btnSm:  { background:C.bg2, color:C.sub, border:`1px solid ${C.border}`, borderRadius:8, padding:'6px 12px', cursor:'pointer', fontSize:12 },
  btnRed: { background:'transparent', color:C.red, border:`1px solid rgba(239,68,68,.3)`, borderRadius:8, padding:'6px 12px', cursor:'pointer', fontSize:12 },
  btnGrn: { background:C.green, color:'#fff', border:'none', borderRadius:8, padding:'7px 14px', cursor:'pointer', fontSize:12, fontWeight:600 },
  grid2:  { display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 },
  card:   { background:C.bg2, border:`1px solid ${C.border}`, borderRadius:12, marginBottom:12 },
  cHdr:   { padding:'14px 18px', borderBottom:`1px solid ${C.border}`, display:'flex', alignItems:'center', justifyContent:'space-between' },
  cBdy:   { padding:'16px 18px' },
  label:  { fontSize:12, color:C.sub, marginBottom:5, display:'block' },
  input:  { width:'100%', background:C.bg, border:`1px solid ${C.border}`, borderRadius:8, padding:'8px 11px', color:C.text, fontSize:13, outline:'none', marginBottom:11, fontFamily:'inherit' },
  tarea:  { width:'100%', background:C.bg, border:`1px solid ${C.border}`, borderRadius:8, padding:'8px 11px', color:C.text, fontSize:13, outline:'none', marginBottom:11, resize:'vertical', minHeight:70, fontFamily:'inherit' },
  sel:    { width:'100%', background:C.bg, border:`1px solid ${C.border}`, borderRadius:8, padding:'8px 11px', color:C.text, fontSize:13, marginBottom:11 },
  badge:  (c) => ({ background:c+'22', color:c, padding:'2px 8px', borderRadius:10, fontSize:11, fontWeight:600 }),
  toggle: (on) => ({
    display:'inline-flex', alignItems:'center', gap:6, cursor:'pointer',
    fontSize:12, color: on?C.green:C.muted
  }),
  trk:    (on) => ({ width:36, height:20, borderRadius:10, background:on?C.blue:C.border, position:'relative', transition:'background .2s', flexShrink:0 }),
  trkT:   (on) => ({ position:'absolute', top:2, left:on?16:2, width:16, height:16, borderRadius:'50%', background:'#fff', transition:'left .2s' }),
  hr:     { border:'none', borderTop:`1px solid ${C.border}`, margin:'14px 0' },
  ok:     { background:'rgba(34,197,94,.1)', color:'#4ade80', borderRadius:8, padding:'9px 12px', fontSize:12, marginBottom:10 },
  err:    { background:'rgba(239,68,68,.1)', color:'#f87171', borderRadius:8, padding:'9px 12px', fontSize:12, marginBottom:10 },
  overlay:{ position:'fixed', inset:0, background:'rgba(0,0,0,.75)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000, padding:16 },
  modal:  { background:C.bg2, border:`1px solid ${C.border}`, borderRadius:16, width:'100%', maxWidth:560, maxHeight:'88vh', overflowY:'auto', padding:24 },
  canvas: { flex:1, background:'#080f1e', borderRadius:12, position:'relative', overflow:'hidden', border:`1px solid ${C.border}` },
  no:     (tipo, sel) => ({
    position:'absolute', background:C.bg2,
    border:`1.5px solid ${sel?(TIPO_NO[tipo]?.cor||C.blue):C.border}`,
    borderLeft:`4px solid ${TIPO_NO[tipo]?.cor||C.blue}`,
    borderRadius:8, padding:'8px 12px', minWidth:160,
    cursor:'pointer', userSelect:'none',
    boxShadow: sel?`0 0 0 2px ${TIPO_NO[tipo]?.cor||C.blue}33`:'none',
    transition:'border-color .1s'
  }),
  noTit:  { fontSize:12, fontWeight:600, color:C.text },
  noSub:  { fontSize:10, color:C.muted, marginTop:2 },
  aresta: { position:'absolute', pointerEvents:'none' },
  tabs:   { display:'flex', gap:0, borderBottom:`1px solid ${C.border}`, marginBottom:14 },
  tab:    (a) => ({ padding:'7px 14px', background:'none', border:'none', cursor:'pointer', fontSize:12, color:a?C.blue:C.sub, borderBottom:`2px solid ${a?C.blue:'transparent'}` }),
  kpi:    { background:C.bg2, border:`1px solid ${C.border}`, borderRadius:10, padding:'14px 16px', textAlign:'center' },
  kpiV:   (c=C.blue) => ({ fontSize:24, fontWeight:700, color:c }),
  kpiL:   { fontSize:11, color:C.muted, marginTop:2 },
  sessRow:{ padding:'8px 0', borderBottom:`1px solid #1e293b`, display:'flex', alignItems:'center', justifyContent:'space-between', fontSize:12 },
};

function Toggle({ value, onChange, label }) {
  return (
    <div style={s.toggle(value)} onClick={() => onChange(!value)}>
      <div style={s.trk(value)}><div style={s.trkT(value)} /></div>
      {label}
    </div>
  );
}

// ── Editor Visual do Fluxo ────────────────────────────────────────
function EditorFluxo({ flow: flowInicial, onVoltar, onSalvo }) {
  const [flow, setFlow]       = useState(flowInicial);
  const [nos, setNos]         = useState([]);
  const [arestas, setArestas] = useState([]);
  const [selNo, setSelNo]     = useState(null);
  const [editNo, setEditNo]   = useState(null);
  const [novaAresta, setNA]   = useState(null);
  const [msg, setMsg]         = useState(null);
  const [saving, setSav]      = useState(false);
  const canvasRef             = useRef(null);
  const dragRef               = useRef(null);

  const carregar = useCallback(() => {
    api.get(`/flows/${flow.id}`).then(r => {
      setNos(r.data.nos);
      setArestas(r.data.arestas);
    });
  }, [flow.id]);

  useEffect(() => { carregar(); }, [carregar]);

  const salvarMeta = async (updates) => {
    await api.patch(`/flows/${flow.id}`, updates);
    setFlow(f => ({ ...f, ...updates }));
    onSalvo && onSalvo();
  };

  const addNo = async (tipo) => {
    const { data } = await api.post(`/flows/${flow.id}/nos`, {
      tipo, label: TIPO_NO[tipo]?.label || tipo,
      pos_x: 200 + Math.random()*100, pos_y: 200 + Math.random()*100
    });
    setNos(prev => [...prev, data]);
  };

  const salvarNo = async (no, config) => {
    await api.patch(`/flows/nos/${no.id}`, { label: no.label, config });
    setNos(prev => prev.map(n => n.id===no.id ? { ...n, label:no.label, config } : n));
    setEditNo(null);
  };

  const removerNo = async (noId) => {
    await api.delete(`/flows/nos/${noId}`);
    setNos(prev => prev.filter(n => n.id !== noId));
    setArestas(prev => prev.filter(a => a.origem_id!==noId && a.destino_id!==noId));
  };

  const addAresta = async (origemId, destinoId, condicao, label) => {
    const { data } = await api.post(`/flows/${flow.id}/arestas`, { origem_id:origemId, destino_id:destinoId, condicao, label });
    setArestas(prev => [...prev, data]);
  };

  const removerAresta = async (id) => {
    await api.delete(`/flows/arestas/${id}`);
    setArestas(prev => prev.filter(a => a.id !== id));
  };

  // Drag nos nós do canvas
  const onMouseDown = (e, no) => {
    e.stopPropagation();
    setSelNo(no.id);
    const startX = e.clientX - no.pos_x;
    const startY = e.clientY - no.pos_y;
    dragRef.current = { noId: no.id, startX, startY };

    const onMove = (ev) => {
      const nx = ev.clientX - dragRef.current.startX;
      const ny = ev.clientY - dragRef.current.startY;
      setNos(prev => prev.map(n => n.id===no.id ? {...n, pos_x:nx, pos_y:ny} : n));
    };
    const onUp = async (ev) => {
      const nx = ev.clientX - dragRef.current.startX;
      const ny = ev.clientY - dragRef.current.startY;
      await api.patch(`/flows/nos/${no.id}`, { pos_x:Math.round(nx), pos_y:Math.round(ny) });
      dragRef.current = null;
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
    };
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
  };

  const noSel = nos.find(n => n.id === selNo);

  return (
    <div style={{ display:'flex', flexDirection:'column', height:'100%', gap:12 }}>
      {/* Toolbar do editor */}
      <div style={{ display:'flex', alignItems:'center', gap:10, flexWrap:'wrap' }}>
        <button style={s.btnSm} onClick={onVoltar}>← Voltar</button>
        <span style={{ fontSize:14, fontWeight:600, color:C.text }}>{flow.nome}</span>
        <div style={{ marginLeft:'auto', display:'flex', gap:8, alignItems:'center' }}>
          <Toggle value={flow.ativo} onChange={v => salvarMeta({ ativo:v })}
            label={flow.ativo ? 'Ativo' : 'Inativo'} />
          {Object.keys(TIPO_NO).filter(t=>t!=='inicio'&&t!=='fim').map(tipo => (
            <button key={tipo} style={{ ...s.btnSm, borderColor:TIPO_NO[tipo]?.cor+'44' }}
              onClick={() => addNo(tipo)} title={`Adicionar nó: ${TIPO_NO[tipo]?.label}`}>
              {TIPO_NO[tipo]?.icone}
            </button>
          ))}
        </div>
      </div>

      {msg && <div style={msg.ok?s.ok:s.err}>{msg.txt}</div>}

      {/* Canvas + painel lateral */}
      <div style={{ display:'flex', gap:12, flex:1, minHeight:0 }}>
        {/* Canvas */}
        <div ref={canvasRef} style={{ ...s.canvas, flex:1 }}
          onClick={() => setSelNo(null)}>
          {/* SVG das arestas */}
          <svg style={{ position:'absolute', inset:0, width:'100%', height:'100%', pointerEvents:'none' }}>
            {arestas.map(ar => {
              const orig = nos.find(n => n.id===ar.origem_id);
              const dest = nos.find(n => n.id===ar.destino_id);
              if (!orig||!dest) return null;
              const x1 = orig.pos_x+80, y1 = orig.pos_y+30;
              const x2 = dest.pos_x+80, y2 = dest.pos_y;
              const mx = (x1+x2)/2, my = (y1+y2)/2;
              const cor = CONDICOES.find(c=>c.val===ar.condicao)
                ? (ar.condicao==='opcao_1'?C.green:ar.condicao==='opcao_2'?C.red:C.muted)
                : C.blue;
              return (
                <g key={ar.id}>
                  <path d={`M${x1} ${y1} C${x1} ${y1+60} ${x2} ${y2-60} ${x2} ${y2}`}
                    fill="none" stroke={cor} strokeWidth="1.5"
                    strokeDasharray={ar.condicao?'5 3':null}
                    markerEnd="url(#arrowh)" opacity="0.7" />
                  {ar.label && (
                    <text x={mx} y={my} textAnchor="middle" fontSize="10"
                      fill={cor} dy="-3">{ar.label}</text>
                  )}
                  <defs>
                    <marker id="arrowh" viewBox="0 0 10 10" refX="8" refY="5"
                      markerWidth="5" markerHeight="5" orient="auto">
                      <path d="M2 1L8 5L2 9" fill="none" stroke={cor} strokeWidth="1.5"/>
                    </marker>
                  </defs>
                </g>
              );
            })}
          </svg>

          {/* Nós */}
          {nos.map(no => (
            <div key={no.id}
              style={{ ...s.no(no.tipo, selNo===no.id), left:no.pos_x, top:no.pos_y }}
              onMouseDown={e => onMouseDown(e, no)}
              onClick={e => { e.stopPropagation(); setSelNo(no.id); }}>
              <div style={s.noTit}>
                {TIPO_NO[no.tipo]?.icone} {no.label}
              </div>
              {no.tipo==='mensagem' && no.config?.texto && (
                <div style={s.noSub}>{(no.config.texto||'').substring(0,40)}...</div>
              )}
              {no.tipo==='pergunta' && no.config?.variavel && (
                <div style={s.noSub}>var: {no.config.variavel}</div>
              )}
              {no.tipo==='aguardar' && (
                <div style={s.noSub}>{no.config?.segundos||2}s</div>
              )}
              {no.tipo==='acao' && (
                <div style={s.noSub}>{no.config?.acao||'...'}</div>
              )}
            </div>
          ))}

          {nos.length === 0 && (
            <div style={{ position:'absolute', inset:0, display:'flex', alignItems:'center',
              justifyContent:'center', color:C.muted, fontSize:13 }}>
              Os nós do fluxo aparecem aqui. Use os botões acima para adicionar.
            </div>
          )}
        </div>

        {/* Painel lateral — config do nó selecionado */}
        {noSel && (
          <div style={{ width:280, background:C.bg2, border:`1px solid ${C.border}`,
            borderRadius:12, padding:16, overflowY:'auto', flexShrink:0 }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:12 }}>
              <div style={{ fontSize:13, fontWeight:600, color:C.text }}>
                {TIPO_NO[noSel.tipo]?.icone} {noSel.label}
              </div>
              <button style={s.btnRed} onClick={() => removerNo(noSel.id)}>✕</button>
            </div>

            <label style={s.label}>Nome do nó</label>
            <input style={s.input} value={noSel.label}
              onChange={e => setNos(prev => prev.map(n => n.id===noSel.id ? {...n,label:e.target.value} : n))}
              onBlur={() => api.patch(`/flows/nos/${noSel.id}`, { label:noSel.label })} />

            {/* Config por tipo */}
            <ConfigNo no={noSel} onSalvar={cfg => salvarNo(noSel, cfg)} />

            <div style={s.hr} />

            {/* Arestas de saída */}
            <div style={{ fontSize:12, fontWeight:600, color:C.sub, marginBottom:8 }}>
              Conexões de saída
            </div>
            {arestas.filter(a=>a.origem_id===noSel.id).map(ar => {
              const dest = nos.find(n=>n.id===ar.destino_id);
              return (
                <div key={ar.id} style={{ display:'flex', alignItems:'center', gap:6,
                  fontSize:11, color:C.muted, padding:'4px 0',
                  borderBottom:`1px solid #1e293b` }}>
                  <span style={{ flex:1 }}>→ {dest?.label||'?'} {ar.label&&`(${ar.label})`}</span>
                  <button style={{ background:'none', border:'none', color:C.red,
                    cursor:'pointer', fontSize:11 }}
                    onClick={() => removerAresta(ar.id)}>✕</button>
                </div>
              );
            })}

            {/* Adicionar nova conexão */}
            <div style={{ marginTop:10 }}>
              <label style={s.label}>Conectar a</label>
              <select style={s.sel} id={`conn-${noSel.id}`}>
                <option value="">Selecionar nó...</option>
                {nos.filter(n=>n.id!==noSel.id).map(n => (
                  <option key={n.id} value={n.id}>{n.label}</option>
                ))}
              </select>
              <select style={s.sel} id={`cond-${noSel.id}`}>
                <option value="">Sem condição</option>
                {CONDICOES.map(c => <option key={c.val} value={c.val}>{c.label}</option>)}
              </select>
              <button style={s.btn} onClick={() => {
                const destId = document.getElementById(`conn-${noSel.id}`)?.value;
                const cond   = document.getElementById(`cond-${noSel.id}`)?.value || null;
                if (destId) addAresta(noSel.id, destId, cond||null, null);
              }}>+ Conectar</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ── Config por tipo de nó ─────────────────────────────────────────
function ConfigNo({ no, onSalvar }) {
  const [cfg, setCfg] = useState(no.config || {});
  useEffect(() => { setCfg(no.config || {}); }, [no.id]);
  const salvar = () => onSalvar(cfg);

  return (
    <div>
      {no.tipo === 'mensagem' && (
        <>
          <label style={s.label}>Tipo</label>
          <select style={s.sel} value={cfg.tipo||'texto'} onChange={e=>setCfg(c=>({...c,tipo:e.target.value}))}>
            <option value="texto">Texto</option>
            <option value="imagem">Imagem (URL)</option>
            <option value="documento">Documento (URL)</option>
          </select>
          <label style={s.label}>
            Mensagem <span style={{color:C.muted,fontWeight:400}}>— use {'{nome}'} {'{variavel}'}</span>
          </label>
          <textarea style={s.tarea} value={cfg.texto||''} onChange={e=>setCfg(c=>({...c,texto:e.target.value}))} />
          {cfg.tipo !== 'texto' && (
            <>
              <label style={s.label}>URL da mídia</label>
              <input style={s.input} value={cfg.media_url||''} onChange={e=>setCfg(c=>({...c,media_url:e.target.value}))} />
            </>
          )}
        </>
      )}

      {no.tipo === 'pergunta' && (
        <>
          <label style={s.label}>Texto da pergunta</label>
          <textarea style={s.tarea} value={cfg.texto||''} onChange={e=>setCfg(c=>({...c,texto:e.target.value}))} />
          <label style={s.label}>Salvar resposta na variável</label>
          <input style={s.input} value={cfg.variavel||''} placeholder="ex: nome_completo"
            onChange={e=>setCfg(c=>({...c,variavel:e.target.value}))} />
          <label style={s.label}>Timeout sem resposta (minutos)</label>
          <input style={s.input} type="number" value={cfg.timeout_min||1440}
            onChange={e=>setCfg(c=>({...c,timeout_min:parseInt(e.target.value)}))} />
        </>
      )}

      {no.tipo === 'aguardar' && (
        <>
          <label style={s.label}>Aguardar (segundos)</label>
          <input style={s.input} type="number" min="1" value={cfg.segundos||2}
            onChange={e=>setCfg(c=>({...c,segundos:parseInt(e.target.value)}))} />
        </>
      )}

      {no.tipo === 'ia' && (
        <>
          <label style={s.label}>Instrução extra para o Gemini</label>
          <textarea style={s.tarea} value={cfg.system_extra||''}
            placeholder="ex: Foque em responder sobre preços e matrículas"
            onChange={e=>setCfg(c=>({...c,system_extra:e.target.value}))} />
          <label style={s.label}>Máx. tokens de resposta</label>
          <input style={s.input} type="number" value={cfg.max_tokens||400}
            onChange={e=>setCfg(c=>({...c,max_tokens:parseInt(e.target.value)}))} />
        </>
      )}

      {no.tipo === 'acao' && (
        <>
          <label style={s.label}>Ação</label>
          <select style={s.sel} value={cfg.acao||''} onChange={e=>setCfg(c=>({...c,acao:e.target.value}))}>
            <option value="">Selecionar ação...</option>
            <option value="kanban_mover">Mover card no Kanban</option>
            <option value="criar_aviso">Criar aviso para atendente</option>
            <option value="iniciar_flow">Iniciar outro fluxo</option>
            <option value="webhook">Disparar webhook (N8N)</option>
          </select>
          {cfg.acao === 'kanban_mover' && (
            <>
              <label style={s.label}>Coluna destino</label>
              <input style={s.input} value={cfg.coluna_nome||''} placeholder="ex: Agendamento"
                onChange={e=>setCfg(c=>({...c,coluna_nome:e.target.value}))} />
              <label style={s.label}>Substatus</label>
              <input style={s.input} value={cfg.substatus||''} placeholder="ex: agendou"
                onChange={e=>setCfg(c=>({...c,substatus:e.target.value}))} />
            </>
          )}
          {cfg.acao === 'criar_aviso' && (
            <>
              <label style={s.label}>Mensagem do aviso</label>
              <input style={s.input} value={cfg.mensagem||''} placeholder="ex: {nome} agendou visita"
                onChange={e=>setCfg(c=>({...c,mensagem:e.target.value}))} />
            </>
          )}
          {cfg.acao === 'iniciar_flow' && (
            <>
              <label style={s.label}>Nome do fluxo a iniciar</label>
              <input style={s.input} value={cfg.flow_nome||''}
                onChange={e=>setCfg(c=>({...c,flow_nome:e.target.value}))} />
            </>
          )}
          {cfg.acao === 'webhook' && (
            <>
              <label style={s.label}>URL do webhook (N8N)</label>
              <input style={s.input} value={cfg.url||''} placeholder="https://..."
                onChange={e=>setCfg(c=>({...c,url:e.target.value}))} />
            </>
          )}
        </>
      )}

      {!['inicio','fim','condicao'].includes(no.tipo) && (
        <button style={s.btnGrn} onClick={salvar}>💾 Salvar nó</button>
      )}
    </div>
  );
}

// ── Página principal ──────────────────────────────────────────────
export default function FlowBuilder() {
  const { socket }              = useSocket();
  const [flows, setFlows]       = useState([]);
  const [stats, setStats]       = useState(null);
  const [editando, setEditando] = useState(null);
  const [aba, setAba]           = useState('flows');
  const [sessoes, setSessoes]   = useState([]);
  const [criando, setCriando]   = useState(false);
  const [novoFlow, setNF]       = useState({ nome:'', descricao:'', gatilho:'primeira_mensagem', prioridade:0 });
  const [msg, setMsg]           = useState(null);

  const carregar = useCallback(() => {
    api.get('/flows').then(r => setFlows(r.data));
    api.get('/flows/stats/geral').then(r => setStats(r.data)).catch(()=>{});
  }, []);

  useEffect(() => { carregar(); }, [carregar]);

  useEffect(() => {
    if (aba === 'sessoes') {
      api.get('/flows/sessoes/lista?limit=30').then(r => setSessoes(r.data)).catch(()=>{});
    }
  }, [aba]);

  useEffect(() => {
    if (!socket) return;
    socket.on('flow_concluido', carregar);
    return () => socket.off('flow_concluido', carregar);
  }, [socket, carregar]);

  const criarFlow = async () => {
    try {
      await api.post('/flows', novoFlow);
      setMsg({ ok:true, txt:'Fluxo criado!' });
      setCriando(false);
      carregar();
    } catch (e) { setMsg({ ok:false, txt: e.response?.data?.error || 'Erro' }); }
  };

  const toggleAtivo = async (flow) => {
    await api.patch(`/flows/${flow.id}`, { ativo: !flow.ativo });
    carregar();
  };

  const removerFlow = async (id) => {
    if (!window.confirm('Remover este fluxo?')) return;
    await api.delete(`/flows/${id}`);
    carregar();
  };

  const iniciarManual = async (flow, atendentes) => {
    const phone = prompt('Número do contato (ex: 14999887766):');
    if (!phone) return;
    const inst  = prompt('Nome da instância Evolution API:');
    if (!inst) return;
    try {
      await api.post('/flows/iniciar-manual', {
        flow_nome: flow.nome, phone, instance_name: inst
      });
      alert('Fluxo iniciado!');
    } catch (e) { alert(e.response?.data?.error || 'Erro'); }
  };

  if (editando) {
    return (
      <div style={{ height:'calc(100vh - 80px)', display:'flex', flexDirection:'column' }}>
        <EditorFluxo flow={editando} onVoltar={() => setEditando(null)} onSalvo={carregar} />
      </div>
    );
  }

  const fmtHora = d => d ? new Date(d).toLocaleString('pt-BR') : '';

  return (
    <div>
      <div style={s.tbar}>
        <div>
          <div style={s.title}>Flow Builder</div>
          <div style={{ fontSize:12, color:C.muted }}>Construtor visual de fluxos de conversa</div>
        </div>
        <button style={{ ...s.btn, marginLeft:'auto' }} onClick={() => setCriando(!criando)}>
          {criando ? '✕ Cancelar' : '+ Novo fluxo'}
        </button>
      </div>

      {/* KPIs */}
      {stats && (
        <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:12, marginBottom:20 }}>
          <div style={s.kpi}><div style={s.kpiV(C.blue)}>{stats.sessoes_ativas||0}</div><div style={s.kpiL}>Sessões ativas</div></div>
          <div style={s.kpi}><div style={s.kpiV(C.green)}>{stats.iniciadas_hoje||0}</div><div style={s.kpiL}>Iniciadas hoje</div></div>
          <div style={s.kpi}><div style={s.kpiV(C.purple)}>{stats.concluidas_hoje||0}</div><div style={s.kpiL}>Concluídas hoje</div></div>
          <div style={s.kpi}><div style={s.kpiV('#f97316')}>{stats.tokens_hoje||0}</div><div style={s.kpiL}>Tokens Gemini hoje</div></div>
        </div>
      )}

      {/* Formulário novo fluxo */}
      {criando && (
        <div style={s.card}>
          <div style={s.cHdr}><div style={{ fontSize:14, fontWeight:600, color:C.sub }}>Novo fluxo</div></div>
          <div style={s.cBdy}>
            {msg && <div style={msg.ok?s.ok:s.err}>{msg.txt}</div>}
            <div style={s.grid2}>
              <div>
                <label style={s.label}>Nome</label>
                <input style={s.input} value={novoFlow.nome} placeholder="ex: Boas-vindas"
                  onChange={e=>setNF(f=>({...f,nome:e.target.value}))} />
              </div>
              <div>
                <label style={s.label}>Gatilho de ativação</label>
                <select style={s.sel} value={novoFlow.gatilho}
                  onChange={e=>setNF(f=>({...f,gatilho:e.target.value}))}>
                  <option value="primeira_mensagem">Primeira mensagem do contato</option>
                  <option value="palavra_chave">Palavra-chave na mensagem</option>
                  <option value="manual">Ativação manual pelo atendente</option>
                  <option value="fora_horario">Fora do horário de atendimento</option>
                  <option value="campanha">Ativado por campanha</option>
                </select>
              </div>
            </div>
            <label style={s.label}>Descrição</label>
            <input style={s.input} value={novoFlow.descricao}
              onChange={e=>setNF(f=>({...f,descricao:e.target.value}))} />
            <button style={s.btn} onClick={criarFlow} disabled={!novoFlow.nome}>Criar</button>
          </div>
        </div>
      )}

      <div style={s.tabs}>
        {[['flows','🔀 Fluxos'],['sessoes','📡 Sessões ativas']].map(([k,l])=>(
          <button key={k} style={s.tab(aba===k)} onClick={()=>setAba(k)}>{l}</button>
        ))}
      </div>

      {aba === 'flows' && (
        <div>
          {flows.length === 0 && (
            <div style={{ color:C.muted, textAlign:'center', padding:40, fontSize:13 }}>
              Nenhum fluxo criado. Os 4 fluxos do Grupo D1 são carregados automaticamente na inicialização.
            </div>
          )}
          {flows.map(flow => (
            <div key={flow.id} style={s.card}>
              <div style={s.cHdr}>
                <div>
                  <div style={{ fontSize:14, fontWeight:600, color:C.text, display:'flex', alignItems:'center', gap:8 }}>
                    {flow.nome}
                    <span style={s.badge(flow.ativo?C.green:C.muted)}>
                      {flow.ativo?'Ativo':'Inativo'}
                    </span>
                    <span style={s.badge(C.blue)}>{flow.gatilho.replace(/_/g,' ')}</span>
                  </div>
                  {flow.descricao && <div style={{ fontSize:11, color:C.muted, marginTop:2 }}>{flow.descricao}</div>}
                </div>
                <div style={{ display:'flex', gap:8 }}>
                  <button style={s.btnSm} onClick={() => setEditando(flow)}>✏️ Editar</button>
                  <button style={s.btnSm} onClick={() => iniciarManual(flow)}>▶ Iniciar</button>
                  <Toggle value={flow.ativo} onChange={() => toggleAtivo(flow)} label="" />
                  <button style={s.btnRed} onClick={() => removerFlow(flow.id)}>✕</button>
                </div>
              </div>
              <div style={{ padding:'10px 18px', display:'flex', gap:20 }}>
                <span style={{ fontSize:12, color:C.muted }}>{flow.total_nos} nós</span>
                <span style={{ fontSize:12, color:C.blue }}>{flow.sessoes_ativas} ativas</span>
                <span style={{ fontSize:12, color:C.green }}>{flow.concluidas_hoje} concluídas hoje</span>
                {flow.prioridade > 0 && <span style={{ fontSize:12, color:C.yellow }}>Prioridade {flow.prioridade}</span>}
              </div>
            </div>
          ))}
        </div>
      )}

      {aba === 'sessoes' && (
        <div style={s.card}>
          {sessoes.map(s_ => (
            <div key={s_.id} style={s.sessRow}>
              <div>
                <div style={{ fontSize:12, color:C.text, fontWeight:500 }}>{s_.phone}</div>
                <div style={{ fontSize:10, color:C.muted }}>{s_.flow_nome} · {s_.no_atual_label||'–'}</div>
              </div>
              <div style={{ display:'flex', gap:8, alignItems:'center' }}>
                <span style={s.badge(s_.status==='ativo'?C.green:s_.status==='concluido'?C.blue:C.muted)}>
                  {s_.status}
                </span>
                <span style={{ fontSize:10, color:C.muted }}>{fmtHora(s_.updated_at)}</span>
              </div>
            </div>
          ))}
          {!sessoes.length && <div style={{ padding:20, color:C.muted, fontSize:13 }}>Nenhuma sessão.</div>}
        </div>
      )}
    </div>
  );
}
